import { seoContent } from '@/mocks/seoContent';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20composition%20of%20contemporary%20fashion%20items%20including%20footwear%20clothing%20and%20accessories%20scattered%20organically%20on%20warm%20sand%20colored%20paper%20background%20soft%20natural%20daylight%20from%20large%20window%20creating%20gentle%20highlights%20modern%20lifestyle%20editorial%20aesthetic%20neutral%20beige%20and%20terracotta%20tone%20palette%20clean%20minimalist%20composition%20with%20artistic%20negative%20space&width=1920&height=1080&seq=hero-main-v3&orientation=landscape"
          alt="OOPBuy Spreadsheet product collection lifestyle arrangement"
          title="OOPBuy Spreadsheet - Product Sourcing Guide"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full section-container">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-16">
          <div className="lg:w-1/2 text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-background-50 leading-tight">
              {seoContent.heroTitle}
            </h1>
            <p className="mt-4 text-lg md:text-xl text-background-50/90 font-light leading-relaxed max-w-lg mx-auto lg:mx-0">
              {seoContent.heroSubtitle}
            </p>
            <p className="mt-6 text-sm md:text-base text-background-50/70 leading-relaxed max-w-md mx-auto lg:mx-0">
              {seoContent.heroDescription}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="btn-primary px-8 py-3.5 text-sm w-full sm:w-auto text-center"
              >
                <i className="ri-shopping-bag-3-line mr-2"></i>
                Explore OOPBuy Spreadsheet
              </a>
              <a
                href="/article/what-is-oopbuy-spreadsheet"
                className="flex items-center gap-2 text-background-50 hover:text-background-50/80 text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                Read Full Guide
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="lg:w-1/2 w-full">
            <div className="bg-background-50/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-background-50/20">
              <div className="grid grid-cols-3 gap-3">
                {['Shoes', 'Hoodies', 'T-Shirts', 'Jackets', 'Bags', 'Jersey'].map((label) => (
                  <div
                    key={label}
                    className="bg-background-50/15 backdrop-blur-sm rounded-xl p-3 md:p-4 text-center hover:bg-background-50/25 transition-all duration-200 cursor-pointer"
                  >
                    <span className="text-background-50 text-xs md:text-sm font-medium whitespace-nowrap">{label}</span>
                  </div>
                ))}
              </div>
              <p className="text-center text-background-50/60 text-xs mt-4">
                14+ product categories organized in the OOPBuy Spreadsheet
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}